export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function capitalizeFirstLetterSp(str: string) {
  return str
    .split(' ')
    .map(capitalizeFirstLetter)
    .join(' ');
}
